import JsonLandingPageTemplate from '../../templates/LandingV3/JsonLandingPageTemplate';

export default JsonLandingPageTemplate;
